<app-modal-header (closeModal)="close()" [isShowCloseBtn]="!isExternalMode"></app-modal-header>
<app-modal-body>
  <h1 class="fs-5 text-truncate pe-2">{{ requestSentTranslationKey | translate }}</h1>
  @if (type === MeetingOption.UNSTRUCTURED) {
    <p class="mb-0">
      {{ 'YOU_WILL_BE_ABLE_TO_DISCUSS_AND_CHAT_WITH_SOMEONE_ON_MESSAGES_ONCE_THEY_RESPOND' | translate: { name } }}
    </p>
  } @else {
    <p class="mb-0" [innerHTML]="plannerTranslationKey | translate: { name, planner: plannerLabel }"></p>
  }
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="close()">{{ 'CLOSE' | translate }}</button>
</app-modal-footer>
